export { default as fontExists } from "./src/fontExists";
export { default as rtl } from "./src/rtl";
export { default as stringify } from "./src/stringify";
export { default as strip } from "./src/strip";
export { default as TextBox } from "./src/TextBox";
export { default as textSplit } from "./src/textSplit";
export { default as textWidth } from "./src/textWidth";
export { default as textWrap } from "./src/textWrap";
export { default as titleCase } from "./src/titleCase";
export { trim, trimLeft, trimRight } from "./src/trim";


//////////////////
// WEBPACK FOOTER
// ./~/d3plus-text/es/index.js
// module id = hIMF
// module chunks = 0